import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }} style={{alignItems:'center',justifyContent:'center',display:'flex',flexDirection:'column'}}>
        <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
          سياسة الخصوصية – تطبيق واصلك
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          آخر تحديث: 2026
        </Typography>

        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          يولي تطبيق واصلك أهمية كبيرة لحماية خصوصية المستخدمين، ويهدف هذا المستند إلى توضيح كيفية جمع المعلومات واستخدامها وحمايتها عند استخدام التطبيق.
        </Typography>

        <Typography variant="h4" component="h2" sx={{ mt: 4, mb: 2 }}>
          1. مقدمة
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          تطبيق واصلك هو تطبيق مخصص لتجار ومحلات السوبر ماركت داخل مدينة عمان، ويتيح لهم طلب المنتجات الأساسية مثل المنظفات والمشروبات الباردة والشيبس وغيرها من السلع التي يحتاجها المحل بشكل يومي بطريقة سهلة وسريعة.
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          باستخدامك للتطبيق فإنك توافق على سياسة الخصوصية هذه.
        </Typography>

        <Typography variant="h4" component="h2" sx={{ mt: 4, mb: 2 }}>
          2. المعلومات التي نقوم بجمعها
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          قد يقوم التطبيق بجمع بعض المعلومات الضرورية لتقديم الخدمة، مثل:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3, mb: 3 }}>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            اسم التاجر أو اسم المحل
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            رقم الهاتف
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            عنوان المحل أو موقعه التقريبي
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            معلومات الطلبات التي يتم إنشاؤها داخل التطبيق
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            بيانات استخدام التطبيق لتحسين الأداء والخدمة
          </Typography>
        </Box>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          نقوم بجمع هذه المعلومات فقط لغرض تشغيل التطبيق وتقديم الخدمة بشكل أفضل.
        </Typography>

        <Typography variant="h4" component="h2" sx={{ mt: 4, mb: 2 }}>
          3. كيفية استخدام المعلومات
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          يتم استخدام المعلومات التي يتم جمعها للأغراض التالية:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3, mb: 3 }}>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            معالجة وتنفيذ طلبات المنتجات
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            التواصل مع التاجر بخصوص الطلبات
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            تحسين تجربة المستخدم داخل التطبيق
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            إدارة الحسابات والطلبات داخل النظام
          </Typography>
        </Box>

        <Typography variant="h4" component="h2" sx={{ mt: 4, mb: 2 }}>
          4. مشاركة المعلومات
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          نحن لا نقوم ببيع أو تأجير أو مشاركة معلومات المستخدمين مع أي أطراف خارجية، إلا في الحالات التالية:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3, mb: 3 }}>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            عند الحاجة لتنفيذ الطلب (مثل شركات التوصيل إن وجدت)
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            إذا كان ذلك مطلوبًا بموجب القانون
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            لحماية حقوق التطبيق أو المستخدمين
          </Typography>
        </Box>

        <Typography variant="h4" component="h2" sx={{ mt: 4, mb: 2 }}>
          5. حماية المعلومات
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          نحرص على اتخاذ الإجراءات التقنية المناسبة لحماية معلومات المستخدمين من الوصول غير المصرح به أو الاستخدام غير القانوني.
        </Typography>

        <Typography variant="h4" component="h2" sx={{ mt: 4, mb: 2 }}>
          6. تخزين البيانات
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          قد يتم تخزين بيانات المستخدمين والطلبات بشكل آمن على خوادم مخصصة لضمان استمرار الخدمة وتحسينها.
        </Typography>

        <Typography variant="h4" component="h2" sx={{ mt: 4, mb: 2 }}>
          7. الفئة المستهدفة
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          تطبيق واصلك مخصص للتجار وأصحاب محلات السوبر ماركت فقط، وليس موجهاً للاستخدام الشخصي أو للأفراد.
        </Typography>

        <Typography variant="h4" component="h2" sx={{ mt: 4, mb: 2 }}>
          8. التعديلات على سياسة الخصوصية
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          قد نقوم بتحديث سياسة الخصوصية من وقت لآخر لتحسين الخدمة أو الامتثال للمتطلبات القانونية. سيتم نشر أي تحديث داخل التطبيق.
        </Typography>

        <Typography variant="h4" component="h2" sx={{ mt: 4, mb: 2 }}>
          9. التواصل معنا
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          في حال وجود أي استفسارات بخصوص سياسة الخصوصية يمكن التواصل معنا عبر:
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          البريد الإلكتروني: support@waslak.com
        </Typography>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
